import { ThemeToggle } from '@repo/ui/components/theme-toggle'
import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuItem,
} from '@repo/ui/components/ui/sidebar'
import { NotificationsDropdown } from '@/components/features/notifications'

export function SidebarUtilities() {
  return (
    <SidebarGroup className="px-0 py-0" data-tour="sidebar-utilities">
      <SidebarMenu>
        <SidebarMenuItem>
          <ThemeToggle variant="sidebar" />
        </SidebarMenuItem>
        <SidebarMenuItem>
          <NotificationsDropdown variant="sidebar" />
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarGroup>
  )
}
